import { Coords, DefaultService as RestApiService } from '../../../swagger-api';
import { MapFilters } from '../map.enum';

export abstract class MapItemDetailsProvider {
  constructor(protected apiService: RestApiService) {}

  abstract readonly filter: MapFilters;

  abstract fetchLocationForItemById(id: string): Promise<Coords>;

  abstract getMarkerIdByEntityId(id: string): string;
}
